// src/App.js
import React, { useState, useEffect } from 'react';
import { HashRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { onAuthStateChange } from './services/auth';
import Home from './pages/Home';
import Login from './pages/Login';
import NewTrip from './pages/NewTrip';
import TripDetail from './pages/TripDetail';
import PublicTrips from './pages/PublicTrips';
import Navbar from './components/Navbar';
import './App.css';
import './styles/alert.css'; // 載入自定義提示框樣式

function App() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsubscribe = onAuthStateChange((user) => {
      setUser(user);
      setLoading(false);
    });

    return () => unsubscribe();
  }, []);

  if (loading) {
    return (
      <div className="loading-container">
        <div className="loading-spinner">載入中...</div>
      </div>
    );
  }

  return (
    <Router>
      <div className="App">
        {user && <Navbar user={user} />}
        <Routes>
          <Route 
            path="/login" 
            element={user ? <Navigate to="/" /> : <Login />} 
          />
          <Route 
            path="/" 
            element={user ? <Home user={user} /> : <Navigate to="/login" />} 
          />
          <Route 
            path="/new-trip" 
            element={user ? <NewTrip user={user} /> : <Navigate to="/login" />} 
          />
          <Route 
            path="/trip/:tripId" 
            element={user ? <TripDetail user={user} /> : <Navigate to="/login" />} 
          />
          <Route 
            path="/public-trips" 
            element={<PublicTrips />} 
          />
        </Routes>
      </div>
    </Router>
  );
}

export default App;